import * as React from "react";
import { connect } from "react-redux";
import { ICoworkSpace } from "shared/model/ICoworkSpace";

import { IState } from "../../state/modules";
import ApplicationsSelectors from "../../state/modules/applications/ApplicationsSelectors";
import { Header } from "./Header";

interface IProps {
  onAddMemberClicked?: () => void;
  cowork?: ICoworkSpace;
  enableAddMember?: boolean;
  showSignIn: boolean;
}

@(connect(
  (state: IState, ownProps: IProps): Partial<IProps> => ({
    cowork: ApplicationsSelectors.currentCowork(state.applications)
  })
) as any)
export default class HeaderContainer extends React.Component<IProps> {
  public render() {
    const { onAddMemberClicked, cowork, enableAddMember, showSignIn } = this.props;
    return (
      <Header
        onAddMemberClicked={onAddMemberClicked}
        enableAddMember={enableAddMember}
        isSignIn={showSignIn}
        coworkName={cowork ? cowork.displayName : undefined}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/HeaderContainer.tsx